import { createContext } from 'react';
export const ModalContext = /*#__PURE__*/createContext({
  variant: 'simple',
  size: 'm',
  changeContextTitleType: () => {}
});
export const ScrollContext = /*#__PURE__*/createContext({
  changeContentOnScroll: () => ({}),
  scrollTop: false
});